import moment from "moment";

import config from "config/config";

export const getManagePaymentStatus = (paymentData) => {
  if (paymentData?.cardStatus?.toLowerCase() !== "expired") {
    let firstdateExpireDate = moment(
      `${paymentData?.expDate?.substring(
        0,
        2
      )}/01/${paymentData?.expDate?.substring(3)}`
    ).format("MM/DD/YYYY");
    let firstDateOfCurrentMonth = `${
      moment().month() + 1
    }/01/${moment().year()}`; // moment Month starts from 0 for jan
    if (
      (moment(firstdateExpireDate).diff(firstDateOfCurrentMonth, "months") ===
        parseInt(config.CREDIT_CARD_EXPIRE_CHECK) ||
        moment().diff(moment(firstdateExpireDate), "months") === 0) &&
      moment().year() === moment(firstdateExpireDate).year()
    ) {
      return "risk";
    } else if (
      moment().month() > moment(firstdateExpireDate).month() &&
      moment().year() === moment(firstdateExpireDate).year()
    ) {
      return "problem";
    } else {
      return "good";
    }
  } else {
    return "problem";
  }
};
